<template>
    <div id="app">
<!--        TODO temporary turn off -->
<!--        <debtor-warning-modal v-if="$store.getters.USER_INFO && $store.getters.USER_INFO.parentId === null"></debtor-warning-modal>-->
        <component :is="layout">
            <router-view/>
        </component>
        <NotificationsList />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import appScss from '!!raw-loader!./assets/sass/app/app.css';
import styleScss from '!!raw-loader!./shared/styles/style.css';
// import DebtorWarningModal from '@/components/app/modals/debtor/DebtorWarningModal.vue';
import customLayout from '@/layouts/customLayout';
import emptyLayout from '@/layouts/emptyLayout';
import loginLayout from '@/layouts/loginLayout';
import mainLayout from '@/layouts/mainLayout';
import profileLayout from '@/layouts/profileLayout';
import { NotificationsList } from '@/shared/ui/notification';

export default {
  data() {
    return {
      styleTag: null,
    };
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || 'main-layout');
    }
  },
  methods: {
    ...mapActions(['checkIsMobile']),
    ...mapActions('layoutModule', ['setupWindowSizeListener']),
    removeGlobalStyle() {
      if (this.styleTag) {
        document.head.removeChild(this.styleTag);
        this.styleTag = null;
      }
    },
    applyGlobalStyle(cssContent) {
      this.removeGlobalStyle();
      this.styleTag = document.createElement('style');
      this.styleTag.type = 'text/css';
      this.styleTag.textContent = cssContent;
      document.head.appendChild(this.styleTag);
    }
  },
  components: { NotificationsList, loginLayout, mainLayout, profileLayout, customLayout, emptyLayout },
  created: function () {
    window.addEventListener('resize', this.checkIsMobile);
    this.setupWindowSizeListener();
    this.checkIsMobile();

    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch('LOGOUT');
        }
        throw err;
      });
    });
  },
  watch: {
    '$route': {
      immediate: true,
      handler(to) {
        const layout = to.meta.layout;
        if (layout === 'profileLayout') {
          this.applyGlobalStyle(appScss);
        } else if (layout === 'emptyLayout') {
          this.applyGlobalStyle(styleScss);
        } else {
          this.removeGlobalStyle();
        }
      }
    }
  }
};
</script>
